// extracted by mini-css-extract-plugin
export default {"p_tye":"_1c39cd350d","slcted":"_9d65f8d47b","slc_color":"_523b6e0f76","item_p":"_3942e350f4","r0":"_0c19281546"};